import { ReactElement } from 'react'
import DualNavLayout from '../components/layout/dual-nav'

export default function CalendarPage(): ReactElement {
  return (
    <DualNavLayout>
      <h1>?</h1>
    </DualNavLayout>
  )
}